import { CurrentTrip } from '../../../types/otpTypes';
import { TableDispatchAction, TableSortProperties } from '../../../types/types';

export default function tableSortReducer(state: TableSortProperties<CurrentTrip>, action: TableDispatchAction<CurrentTrip>): TableSortProperties<CurrentTrip> {
    switch (action.type) {
        case 'CHANGE_SORT': {
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.slice().reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }
            let data = [];
            switch (action.column) {
                case 'delaySeconds':
                case 'vehicleId':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                case 'routeNumber':
                case 'directionVariantName':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as string;
                        const bVal = b[action.column] as string;
                        if (aVal > bVal) {
                            return 1;
                        } else if (aVal < bVal) {
                            return -1;
                        }
                        return 0;
                    });
                    break;
                case 'tripStartTime':
                    data = state.data.sort((a, b) => new Date(a[action.column]).getTime() - new Date(b[action.column]).getTime());
                    break;
                default:
                    data = state.data;
            }
            return {
                column: action.column,
                data: data,
                direction: 'ascending',
            };
        }
        case 'UPDATE_DATA': {
            return {
                ...state,
                data: action.data || [],
            };
        }
    }
}